exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".table.table-header {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n.table-body {\r\n    height: 311px;\r\n    overflow-y: scroll;\r\n}\r\n\r\n.text-center {\r\n    text-align: center;\r\n}\r\n\r\n.text-right {\r\n    text-align: right;\r\n}\r\n\r\ntable th:nth-child(1), table td:nth-child(1) {\r\n    width: 60%;\r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./src/app/views/dashboards/dashboard-table/dashboard-table.css
// module id = 986
// module chunks = 0